import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ReportStatus, STATUS_ORDER } from '../../../models/reports';

type NodeState = 'done' | 'current' | 'pending';

@Component({
  selector: 'app-status-stepper',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './status-stepper.html',
  styleUrl: './status-stepper.css',
})
export class StatusStepper {
  /** Current status of the report this rail represents. */
  @Input({ required: true }) status!: ReportStatus;

  /** Compact hides text labels and shrinks the nodes — used in list rows. */
  @Input() compact = false;

  statuses = STATUS_ORDER;

  currentIndex(): number {
    return this.statuses.indexOf(this.status);
  }

  state(index: number): NodeState {
    const idx = this.currentIndex();
    if (index < idx) return 'done';
    if (index === idx) return 'current';
    return 'pending';
  }
}
